import { useMemo } from "react";

import { DataType } from "@/jenesys-types/data/enums";

export interface EntityNamings {
  singular: string;
  plural: string;
}

const pluralize = (word: string) => {
  if (word.endsWith("s")) return word; // assume it's already plural
  if (/(s|x|z|ch|sh)$/i.test(word)) return `${word}es`;
  if (/[^aeiou]y$/i.test(word)) return `${word.slice(0, -1)}ies`;
  return `${word}s`;
};

const useEntityNamings = (dataType: DataType) =>
  // Saving this for when we need to use it for translations
  useMemo<EntityNamings>(
    () => ({
      singular: `${dataType}`,
      plural: pluralize(dataType)
    }),
    [dataType]
  );
export default useEntityNamings;
